module.exports = __webpack_public_path__ + "media/images/placeholder-5ee61aec353411f6111caac88b1dde76.jpg";